module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": ""
    }
  }, [_c('div', {
    staticClass: "mx-auto g-mb-60 text-center"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Helpful Website Guides")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Below are resources to help you use and navigate the website to the fullest.")])]), _vm._v(" "), _c('div', {
    staticClass: "card-group d-block d-md-flex g-mx-minus-4"
  }, [_c('div', {
    staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
  }, [_c('div', {
    staticClass: "card-body g-bg-white rounded g-pa-40"
  }, [_c('img', {
    staticClass: "help-page-icon g-mb-20",
    attrs: {
      "src": require("../../../../static/assets/img/icons/Help Page Icons/place_order.png")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Order Guide")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
  }, [_vm._v("This document walks you through how to place an order from your prescription.")])]), _vm._v(" "), _c('div', {
    staticClass: "g-help-view-document"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/file/d/1iHkl0Ne8l1Od0fqCDMkSzf_zPvJsj-M-/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("View Document"), _c('i', {
    staticClass: "g-font-size-13 ml-2 material-icons"
  }, [_vm._v("arrow_forward")])]), _vm._v(" "), _c('a', {
    staticClass: "g-float-right g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=1iHkl0Ne8l1Od0fqCDMkSzf_zPvJsj-M-",
      "download": "EVF Portal Flyer",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
  }, [_c('div', {
    staticClass: "card-body g-bg-white rounded g-pa-40"
  }, [_c('img', {
    staticClass: "help-page-icon g-mb-20",
    attrs: {
      "src": require("../../../../static/assets/img/icons/Help Page Icons/track_order.png")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Track Order Guide")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
  }, [_vm._v("This guide demonstrates the features of the Track Order page.")])]), _vm._v(" "), _c('div', {
    staticClass: "g-help-view-document"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/file/d/1hUdv9QbrIj_6Oga78F2yiNJ3decIybfS/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("View Document"), _c('i', {
    staticClass: "g-font-size-13 ml-2 material-icons"
  }, [_vm._v("arrow_forward")])]), _vm._v(" "), _c('a', {
    staticClass: "g-float-right g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=1hUdv9QbrIj_6Oga78F2yiNJ3decIybfS",
      "download": "EVF Portal Flyer",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38232961", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38232961"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpServices.vue
// module id = 491
// module chunks = 3